import React, { Component } from "react";
import dayjs from "dayjs";
import { s360ConfigService } from "../../Services/S360Config";

class MessageA6 extends Component {

    render() {
       let videoURL = this.props.entry.url;
       let style = {};
       if (this.props.entry.data) {
        let data = JSON.parse(this.props.entry.data)
        style.width  = (data.width) ? (data.width+"px"): "100%";
        style.height = (data.height) ? (data.height+"px"): "100%";
       }
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    <video controls style={style}>
                        <source src={videoURL}
                            type="video/mp4" />
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                </div>
                { this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("h:mm a")}</div>}
            </div>
        )
    }

    messageTimeClassName = () => {
      return "s360-message-time-received";
        // switch (this.props.message.type) {
        //     case MessageType.received: return "s360-message-time-received";
        //     default: return "";
        // }
    }

    messageBoxClassName = () => {
      return "s360-message-box-custom-received";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-box-sent";
        //     case MessageType.received: return "s360-message-box-received";
        //     default: return "";
        // }
    }

    messageContainerClassName = () => {
      return "s360-message-cotainer-received";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-cotainer-sent";
        //     case MessageType.received: return "s360-message-cotainer-received";
        //     default: return "";
        // }
    }

    messageBoxStyle = () => {
      return { background: s360ConfigService.config.designDetails.senderMessageColor, fontFamily: s360ConfigService.config.designDetails.SenderMessageFont, fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize, color: s360ConfigService.config.designDetails.senderMessageFontColor }
        // let config = this.props.config;
        // switch (this.props.message.type) {
        //     case MessageType.received: return { height:"105px", background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
        //     case MessageType.sent: return { height:"105px", background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
        //     default: return {}
        // }
    }

    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        return { fontFamily: s360ConfigService.config.designDetails.messageFont, fontSize: s360ConfigService.config.designDetails.messageTimeFontSize, color: s360ConfigService.config.designDetails.messageFontColor }
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        // switch (this.props.message.type) {
        //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }

}

export default MessageA6;
